import React, { useState } from "react";
import { Helmet } from "react-helmet";

import Overview from "./Overview";
import { CustomChip, Header } from "./ui";
import CustomersTab from "./CustomersTab";
import SubscriptionsTab from "./SubscriptionsTab";
import InvoicesTab from "./InvoicesTab";
import ChargesTab from "./ChargesTab";
import ChargeReportTab from "./ChargeReportTab";
import ExpectedFundsTab from "./ExpectedFundsTab";
import RefundsTab from "./RefundsTab";
import ReconciliationTab from "./ReconciliationTab";
import AuditTab from "./AuditTab";
import ApprovalsTab from "./ApprovalsTab";

import "./BillingDev.scss";

const TABS = [
  { key: "overview", label: "Overview" },
  { key: "customers", label: "Customers" },
  { key: "subscriptions", label: "Subscriptions" },
  { key: "invoices", label: "Invoices" },
  { key: "charges", label: "Charges" },
  { key: "chargeReport", label: "Charge Report" },
  { key: "expectedFunds", label: "Expected funds" },
  { key: "refunds", label: "Refunds" },
  { key: "reconciliation", label: "Reconciliation" },
  { key: "audit", label: "Audit" },
  { key: "approvals", label: "Approvals" },
] as const;

type TabKey = (typeof TABS)[number]["key"];

/**
 * [PRD-2043] Read-only developer billing dashboard.
 * Surfaces billing-service data (frontend → monolith → BS). Gated by the
 * `billing.read` permission (Developer + Edge Admin roles).
 */
export default function BillingDev() {
  const [tab, setTab] = useState<TabKey>("overview");

  return (
    <>
      <Helmet>
        <title>Edge | Billing</title>
      </Helmet>

      <Header data={{ heading: "Billing", profileWithIcon: null }} />

      <div style={{ paddingBottom: 24, marginTop: 12 }}>
        <div className="billing-dev-card">
          <div className="billing-dev-tabs">
            {TABS.map((t) => (
              <CustomChip
                key={t.key}
                label={t.label}
                size="small"
                onClick={() => setTab(t.key)}
                variant={tab === t.key ? "filled" : "outlined"}
                color={tab === t.key ? "primary" : "default"}
              />
            ))}
          </div>

          <div>
            {tab === "overview" && <Overview />}
            {tab === "customers" && <CustomersTab />}
            {tab === "subscriptions" && <SubscriptionsTab />}
            {tab === "invoices" && <InvoicesTab />}
            {tab === "charges" && <ChargesTab />}
            {tab === "chargeReport" && <ChargeReportTab />}
            {tab === "expectedFunds" && <ExpectedFundsTab />}
            {tab === "refunds" && <RefundsTab />}
            {tab === "reconciliation" && <ReconciliationTab />}
            {tab === "audit" && <AuditTab />}
            {tab === "approvals" && <ApprovalsTab />}
          </div>
        </div>
      </div>
    </>
  );
}
